import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { HomeComponent } from './home/home.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { BUComponent } from './components/bu/bu.component';
import { UtComponent } from './components/ut/ut.component';
import { GlobalLayoutComponent } from './components/layout/global-layout/global-layout.component';
import { AdminAuthGuard } from './services/guards/admin-auth-guard';
import { ApplicationManagementComponent } from './components/application-management/application-management.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { AuditlogManagementComponent } from './components/auditlog-management/auditlog-management.component';
import { TwoFactorGuard } from './services/guards/auth-2fa-guard';
import { ErrorComponent } from './components/error/error.component';
import { UtilitiesManagementComponent } from './components/utilities/utilities-management.component';

export enum GlobalSidebarItems {
  Bu = 1,
  Ut = 2,
  UserManagement = 3,
  Application = 4,
  AuditLog = 5,
  Utilities = 6
}

const routes: Routes = [
  {
    path: '', component: GlobalLayoutComponent, children: [
      { path: '', component: UserManagementComponent, pathMatch: 'full', canActivate: [AdminAuthGuard], data: { sidebarItem: GlobalSidebarItems.UserManagement } },
      { path: 'login', component: LoginComponent },
      { path: 'user', component: UserManagementComponent, pathMatch: 'full', canActivate: [AdminAuthGuard], data: { sidebarItem: GlobalSidebarItems.UserManagement } },
      { path: 'bu', component: BUComponent, pathMatch: 'full', canActivate: [AdminAuthGuard], data: { sidebarItem: GlobalSidebarItems.Bu } },
      { path: 'ut', component: UtComponent, pathMatch: 'full', canActivate: [AdminAuthGuard], data: { sidebarItem: GlobalSidebarItems.Ut } },
      { path: 'application', component: ApplicationManagementComponent, pathMatch: 'full', canActivate: [AdminAuthGuard, TwoFactorGuard], data: { sidebarItem: GlobalSidebarItems.Application } },
      { path: 'change-password', component: ChangePasswordComponent, pathMatch: 'full', canActivate: [AdminAuthGuard], data: { sidebarItem: GlobalSidebarItems.Application } },
      { path: 'audit-log', component: AuditlogManagementComponent, pathMatch: 'full', data: { sidebarItem: GlobalSidebarItems.AuditLog } },
      { path: 'utilities', component: UtilitiesManagementComponent, pathMatch: 'full', data: {sidebarItem: GlobalSidebarItems.Utilities}},
      { path: 'error', component: ErrorComponent }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
